module.exports = __webpack_public_path__ + "media/images/Ic_close-b0e545df3b29ed862fe2722be1d2f4e2.svg";